import { useCallback, useEffect, useState } from 'react';

import CircleAnimatedProgress from '../circle-animated-progress/circle-animated-progress';
import LoadingCheck from '../loading-check/loading-check';
import styles from './final-summary-step.module.scss';

const STEPS = [
  'Analyzing your goals',
  'Exploring your partner’s profile',
  "Calculating the Moon's influence",
  'Creating your profile',
];

const DURATION = 2000;

const FinalSummaryStep = ({ onNextRequest }: { onNextRequest: () => void }) => {
  const [stepIndex, setStepIndex] = useState(-1);
  const stepCount = STEPS.length;

  const handleStepComplete = useCallback((currentIndex: number) => {
    setStepIndex(currentIndex);
  }, []);

  useEffect(
    () => {
      if (stepIndex === 4) {
        const timeoutId = setTimeout(onNextRequest, 500);
        return () => {
          clearTimeout(timeoutId);
        };
      }
      return undefined;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [stepIndex],
  );

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>
        {stepIndex === 4 ? 'All done' : 'Building up your report'}
      </h2>
      <div>
        <CircleAnimatedProgress
          progressDuration={DURATION * stepCount}
          handleStepComplete={handleStepComplete}
        />
      </div>

      <ul className={styles.listSteps}>
        {STEPS.map((text, index) => (
          <li key={index}>
            <LoadingCheck
              progressDuration={DURATION}
              started={stepIndex >= index}
            />{' '}
            {text}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FinalSummaryStep;
